import {
  BidAmountComponent,
  BondPriceComponent,
  GSpreadComponent,
  YieldComponent,
} from "@goodfill/domain-properties-components";
import { Field } from "../../../../ui-components";
import { PricedBond } from "../../PricedBond";
import { MoreAboutBox } from "./MoreAboutBox";

export const BondDetailAboutTheBid = ({ pricedBond, className }: { pricedBond: PricedBond; className?: string }) => {
  return (
    <MoreAboutBox title="About the Bid" className={className}>
      <div className="grid grid-cols-2 gap-8">
        <Field label={"Bid Price"} textAlign="left" labelClassName="whitespace-unset-important">
          <BondPriceComponent value={pricedBond.bidPrice} />
        </Field>
        <Field label={"Bid Yield"} textAlign="left" labelClassName="whitespace-unset-important">
          <YieldComponent value={pricedBond.bidYield} />
        </Field>
        <Field label={"Bid G-Spread"} textAlign="left" labelClassName="whitespace-unset-important">
          <GSpreadComponent value={pricedBond.bidGSpread} />
        </Field>
        <Field label={"Bid Size"} textAlign="left" labelClassName="whitespace-unset-important">
          <BidAmountComponent value={pricedBond.bidAmount} />
        </Field>
      </div>
    </MoreAboutBox>
  );
};
